export const NikeaFloorRenderImgPaths = {
  3: "https://pub-6b19aa8667db4dd1b4b4d8919b55586e.r2.dev/jpeg-optimizer_Floor3.png",
  4: "https://pub-6b19aa8667db4dd1b4b4d8919b55586e.r2.dev/Floor4.png",
  5: "https://pub-6b19aa8667db4dd1b4b4d8919b55586e.r2.dev/Floor5.png",
  6: "https://pub-6b19aa8667db4dd1b4b4d8919b55586e.r2.dev/Floor6.png",
  7: "https://pub-6b19aa8667db4dd1b4b4d8919b55586e.r2.dev/Floor7.png",
  8: "https://pub-6b19aa8667db4dd1b4b4d8919b55586e.r2.dev/Floor8.png",
  9: "https://pub-6b19aa8667db4dd1b4b4d8919b55586e.r2.dev/Floor9.png",
  10: "https://pub-6b19aa8667db4dd1b4b4d8919b55586e.r2.dev/Floor10.png",
  11: "https://pub-6b19aa8667db4dd1b4b4d8919b55586e.r2.dev/Floor11.png",
  12: "https://pub-6b19aa8667db4dd1b4b4d8919b55586e.r2.dev/Floor12.png",
};
export const NikeaApartmentRenders = {
  50: "https://pub-6b19aa8667db4dd1b4b4d8919b55586e.r2.dev/Nikea50.png",
  55.3: "https://pub-6b19aa8667db4dd1b4b4d8919b55586e.r2.dev/Nikea55.3.png",
  55: "https://pub-6b19aa8667db4dd1b4b4d8919b55586e.r2.dev/Nikea55.png",
  62.7: "https://pub-6b19aa8667db4dd1b4b4d8919b55586e.r2.dev/Nikea62.7.png",
  67: "https://pub-6b19aa8667db4dd1b4b4d8919b55586e.r2.dev/Nikea67.png",
  77.5: "https://pub-6b19aa8667db4dd1b4b4d8919b55586e.r2.dev/Nikea77.5.png",
  81.4: "https://pub-6b19aa8667db4dd1b4b4d8919b55586e.r2.dev/Nikea81.4.png",
  100.2: "https://pub-6b19aa8667db4dd1b4b4d8919b55586e.r2.dev/Nikea100.2.png",
  112.6: "https://pub-6b19aa8667db4dd1b4b4d8919b55586e.r2.dev/Nikea112.6.png",
  117: "https://pub-6b19aa8667db4dd1b4b4d8919b55586e.r2.dev/Nikea117.png",
  123.8: "https://pub-6b19aa8667db4dd1b4b4d8919b55586e.r2.dev/Nikea123.8.png",
  124.5: "https://pub-6b19aa8667db4dd1b4b4d8919b55586e.r2.dev/Nikea124.5.png",
};
